import { ApartmentOutlined } from '@ant-design/icons';
import { Dropdown, Spin } from 'antd';
import { createPortal } from 'react-dom';

import { useOrganizationSelect } from '@app/components/OrganizationSelect/hooks';

import '@app/components/OrganizationSelect/styles/OrganizationSelect.scss';

export const OrganizationSelect = () => {
  const {
    currentOrganization,
    currentName,
    hasMultipleOrganizations,
    isSwitching,
    switchingTo,
    menu,
  } = useOrganizationSelect();

  // Непрозрачный оверлей на весь экран: держится от клика через перезагрузку и
  // до готовности нового профиля, скрывая закрытие меню, сброс стора и пустой
  // каркас перезагруженного приложения. Портал в body: у мобильного сайдбара
  // transform, из-за него position: fixed внутри считался бы от сайдбара.
  const overlay =
    isSwitching &&
    createPortal(
      <div
        className="OrganizationSelect__overlay"
        role="alert"
        aria-live="assertive"
        data-testid="organization-switch-overlay"
      >
        <Spin size="large" />
        <p className="OrganizationSelect__overlay-text">
          Переключаем на «{switchingTo}»…
        </p>
      </div>,
      document.body
    );

  // Меньше двух организаций — переключать нечего, кнопку не показываем (но
  // оверлей после reload всё равно нужен, пока организации не подгрузились).
  if (!hasMultipleOrganizations) {
    return overlay || null;
  }

  return (
    <>
      <Dropdown menu={menu} trigger={['click']} disabled={isSwitching}>
        <button
          type="button"
          data-testid="organization-select"
          className="OrganizationSelect__button"
          title={
            currentOrganization
              ? `Организация: «${currentName}». Нажмите, чтобы переключить`
              : 'Выбор организации'
          }
        >
          <span className="OrganizationSelect__label">
            <ApartmentOutlined />
            Организация
          </span>
          <span className="OrganizationSelect__name">{currentName}</span>
        </button>
      </Dropdown>

      {overlay}
    </>
  );
};
